import api from './api';

export const settingsService = {
  getSettings: async () => {
    try {
      const response = await api.get('/api/settings');
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Get settings error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to load settings',
        data: {
          app_title: 'OC-LANgenthal Vol. 3 - 01.01.26 - 04.01.26',
          nav_title: 'OC-LANgenthal',
          landing_hero_image: null,
          landing_gaming_image: null,
          landing_bar_image: null
        }
      };
    }
  },

  updateSettings: async (data) => {
    try {
      const response = await api.put('/api/settings', data);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Update settings error:', error);
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to update settings'
      };
    }
  },

  uploadLandingImage: async (slot, file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await api.post(`/api/settings/landing-images/${slot}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      });
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to upload image'
      };
    }
  },

  clearLandingImage: async (slot) => {
    try {
      const response = await api.delete(`/api/settings/landing-images/${slot}`);
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Failed to remove image'
      };
    }
  }
};

